function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17 9V5C17 3.34315 18.3431 2 20 2H28C29.6569 2 31 3.34315 31 5V9H27.5V5C27.5 4.72386 27.2761 4.5 27 4.5H21C20.7239 4.5 20.5 4.72386 20.5 5V9H17Z",
  fill: "white"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7 9C4.79086 9 3 10.7909 3 13V18.8C6.5 19.8 12.5 21.2 19.8 19.8V23.5H28.2V19.8C35.5 21.2 41.5 19.8 45 18.8V13C45 10.7909 43.2091 9 41 9H7Z",
  fill: "white"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21 20C21 19.4477 21.4477 19 22 19H26C26.5523 19 27 19.4477 27 20V25C27 25.5523 26.5523 26 26 26H22C21.4477 26 21 25.5523 21 25V20ZM22.5 22C22.2239 22 22 22.2239 22 22.5V23.5C22 23.7761 22.2239 24 22.5 24H25.5C25.7761 24 26 23.7761 26 23.5V22.5C26 22.2239 25.7761 22 25.5 22H22.5Z",
  fill: "white"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M3 21.2V32C3 34.2091 4.79086 36 7 36H41C43.2091 36 45 34.2091 45 32V21.2C41.8 22.2 35.8 23.2 28.5 22.2V24.5C28.5 25.8807 27.3807 27 26 27H22C20.6193 27 19.5 25.8807 19.5 24.5V22.2C12.2 23.2 6.2 22.2 3 21.2Z",
  fill: "white"
});
function SvgOfficeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 48 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeIcon);
export default __webpack_public_path__ + "static/media/office-icon.54062a8f.svg";
export { ForwardRef as ReactComponent };